import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import reducer      from './reducers';
import { DevTools } from './components';

export const history = createHistory({basename: '/web'});

const middleware = compose(
    applyMiddleware(
        thunkMiddleware,            // lets us dispatch() functions
        routerMiddleware(history)   // wire up the router to the redux store
    ),
    DevTools.instrument()
);

export default createStore(
    reducer,
    middleware
);



// WEBPACK FOOTER //
// ./src/store.js